import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Document, Page, pdfjs } from "react-pdf";
import Grid from '@material-ui/core/Grid';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import Iframe from 'react-iframe';
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = theme => ({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    document: {
        width: '100%',
        height: '100%',
    }
});

class PDF2 extends Component{
    state = {
        numPages: null,
        pageNumber: 1,
        windowHeight: undefined,
        windowWidth: undefined,
        zoom:0.5
    }

    goToPrevPage = () =>{
        if ((this.state.pageNumber - 1) > 0)
        this.setState(state => ({ pageNumber: state.pageNumber - 1 }));
    }
   
    goToNextPage = () =>{
        if((this.state.pageNumber + 1)<=this.state.numPages)
        this.setState(state => ({ pageNumber: state.pageNumber + 1 }));
    }

    zoomout = () =>{
        this.setState(state => ({ zoom: state.zoom - 0.3 }));
    }
   
    zoomin = () =>{
        this.setState(state => ({ zoom: state.zoom + 0.3 }));
    }
    

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    componentWillMount(){
        console.log('zooming for : '+this.props.isDesktop)
        // if (this.props.isDesktop){
        //     this.setState({ zoom: 2.0 })
        // }
        // else{
        //     this.setState({ zoom: 0.7 })
        // }
    }

    handleResize = () => this.setState({
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth
      });
    
      componentDidMount() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
        var currentWidth = 0;
    
        if (this.props.isDesktop) {
          console.log("zooming for : " + this.props.isDesktop);
          this.setState({ zoom: 0.5 });
    
          setInterval(() => {
            if (currentWidth !== this.state.windowWidth) {
              currentWidth = this.state.windowWidth;
    
              if (this.state.windowWidth <= 400) {
                this.setState({ zoom: 0.5 });
              } else if (
                this.state.windowWidth > 400 &&
                this.state.windowWidth < 800
              ) {
                this.setState({ zoom: 0.7 });
              } else if (
                this.state.windowWidth >= 800 &&
                this.state.windowWidth < 1200
              ) {
                this.setState({ zoom: 0.7 });
              } else if (this.state.windowWidth >= 1200) {
                this.setState({ zoom: 1.0 });
              }
            }
            console.log(this.state.zoom)
          }, 500);
        }
        else{
          this.setState({ zoom: 0.4 });
        }
      }

    render(){
        // const { classes, file } = this.props;
        let { numPages, pageNumber, zoom } = this.state;

        const { classes, file, fileURLNoName, wordFile } = this.props;
        var fileMobile = "https://drive.google.com/viewerng/viewer?embedded=true&url=" + file + "#toolbar=1&scrollbar=1";
        var fileMobileNoName =  "https://drive.google.com/viewerng/viewer?embedded=true&url=" + fileURLNoName + "#toolbar=1&scrollbar=1";
          console.log('PDF file: '+file)
          console.log('PDF fileMobile: '+fileMobile)
          console.log('PDF fileURLNoName: '+fileURLNoName)

        if (this.props.isAward !== undefined) {
            if (this.props.isAdmin !== undefined) {
              return (
                <div>
                    <div style={{ margin: "5px" }}>
                      <Grid
                        container
                        spacing={8}
                        alignItems="center"
                        direction="column"
                        justify="center"
                      >
                        <Grid item xs={2} spacing={3}>
                          {this.context.t("Download")}:&nbsp;&nbsp;
                          <a target="_blank" href={file}>
                            {this.context.t("PDF")}
                          </a>
                          &nbsp;
                          <a target="_blank" href={wordFile}>
                            {this.context.t("Word")}
                          </a>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </div>
                    <div style={{ display: 'flex', marginLeft: 'auto', marginRight: 'auto', justifyContent: 'center' }}>
                      <Document options={{ workerSrc: "/pdf.worker.js" }} className={classes.docStyle} file={file} onLoadSuccess={this.onDocumentLoadSuccess}>
                        <Page scale={this.state.zoom} width={1000} pageNumber={this.state.pageNumber} />
                      </Document>
                    </div>
                    <p>
                      Page {this.state.pageNumber} of {this.state.numPages}
                    </p>
                    <div>
                      <Button
                        type="button"
                        disabled={pageNumber <= 1}
                        onClick={() => {
                          this.goToPrevPage();
                        }}
                      >
                        Previous
                      </Button>
                      <Button
                        type="button"
                        disabled={pageNumber >= numPages}
                        onClick={() => {
                          this.goToNextPage();
                        }}
                      >
                        Next
                      </Button>
                    </div>
                </div>
              );
            } else {
              return (
                <div style={{textAlign:'center'}}>
                  <Grid
                    container
                    spacing={8}
                    alignItems="center"
                    direction="row"
                    justify="center"
                  >
                    <nav style={{ textAlign:'center', padding:'5px' }}>
                      <a target="_blank" href={file}>
                        {this.context.t("Download PDF")}
                      </a>
                      &nbsp;
                      <a href={wordFile}>{this.context.t("Download Word")}</a>&nbsp;
                    </nav>
                  </Grid>
                  <div >
                  <div style={{ display: 'flex', marginLeft: 'auto', marginRight: 'auto', justifyContent: 'center' }}>
                      <Document options={{ workerSrc: "/pdf.worker.js" }} className={classes.docStyle} file={file} onLoadSuccess={this.onDocumentLoadSuccess}>
                        <Page scale={this.state.zoom} width={1000} pageNumber={this.state.pageNumber} />
                      </Document>
                    </div>
                    <p>
                      Page {this.state.pageNumber} of {this.state.numPages}
                    </p>
                    <div>
                      <Button
                        type="button"
                        disabled={pageNumber <= 1}
                        onClick={() => {
                          this.goToPrevPage();
                        }}
                      >
                        Previous
                      </Button>
                      <Button
                        type="button"
                        disabled={pageNumber >= numPages}
                        onClick={() => {
                          this.goToNextPage();
                        }}
                      >
                        Next
                      </Button>
                    </div>
                  </div>
                </div>
              );
            }
          } else {
            return (
              <div style={{textAlign:'center'}}>
                <div style={{textAlign:'center', padding:'5px'}}>
                  <a style={{textAlign:'center'}} target="_blank" href={file}>
                    {this.context.t("Download PDF")}
                  </a>
                  &nbsp;
                </div>
                <div style={{ height: "100vh", width:'100vw' }}>
                <div style={{ display: 'flex', marginLeft: 'auto', marginRight: 'auto', justifyContent: 'center' }}>
                  <Document options={{ workerSrc: "/pdf.worker.js" }} className={classes.docStyle} file={file} onLoadSuccess={this.onDocumentLoadSuccess}>
                        <Page scale={this.state.zoom} width={1000} pageNumber={this.state.pageNumber} />
                      </Document>
                    </div>
                    <p>
                      Page {this.state.pageNumber} of {this.state.numPages}
                    </p>
                    <div>
                      <Button
                        type="button"
                        disabled={pageNumber <= 1}
                        onClick={() => {
                          this.goToPrevPage();
                        }}
                      >
                        Previous
                      </Button>
                      <Button
                        type="button"
                        disabled={pageNumber >= numPages}
                        onClick={() => {
                          this.goToNextPage();
                        }}
                      >
                        Next
                      </Button>
                    </div>
                </div>
              </div>
            );
          }
        
    }
}

PDF2.contextTypes = {
    t: PropTypes.func
}

export default withStyles(styles)(PDF2);